import styled from 'styled-components'

import FaqList from '~/features/faq/components/FaqList'
import InquiryList from '~/features/inquiry/components/InquiryList'
import PageTabs from '~/features/inquiry/components/PageTabs'
import useInquiryTab from '~/features/inquiry/hooks/useInquiryTab'
import { InquiryTabs } from '~/features/inquiry/types/inquiry'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'

function InquiryPage() {
  const InquiryBgMobile = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/background/inquiry-bg-390.png`
  const InquiryBgPc = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/background/inquiry-bg-1920.png`

  const viewport = useViewport()
  const isMobile = viewport < theme.deviceSizes.medium
  const backgroundImage = isMobile ? InquiryBgMobile : InquiryBgPc
  const { inquiryTab, setInquiryTab } = useInquiryTab()

  return (
    <Wrapper>
      <BackgroundImage $src={backgroundImage} />
      <Title>문의하기</Title>
      <PageTabs
        tabContents={[InquiryTabs.FAQ, InquiryTabs.INQUIRY]}
        selectedTab={inquiryTab}
        $size="md"
        setSelectTab={setInquiryTab}
      />
      {inquiryTab === InquiryTabs.FAQ ? <FaqList /> : <InquiryList />}
    </Wrapper>
  )
}

export default InquiryPage

const Wrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  box-sizing: border-box;
  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: calc(80px + ${theme.size.headerHeight}px);
  margin-bottom: 120px;

  @media ${theme.device.large} {
    padding: 0 60px;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    align-items: start;

    width: 100vw;
    height: auto;
    margin-top: calc(56px + ${theme.size.headerHeight}px);
    padding: 0 20px;
  }
`

const BackgroundImage = styled.div<{ $src: string }>`
  position: fixed;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-image: url(${(props) => props.$src});
  background-attachment: fixed;
  background-size: cover;
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 59px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 28px;
    line-height: 40px;
  }
`
